import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { translations } from "@/lib/i18n";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Showcase from "@/components/site/Showcase";
import ExtraServices from "@/components/site/ExtraServices";
import Commerce from "@/components/site/Commerce";
import Portfolio from "@/components/site/Portfolio";
import ImportExport from "@/components/site/ImportExport";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import ConsultationModal from "@/components/site/ConsultationModal";

const Home = () => {
  const [lang, setLang] = useState(() => localStorage.getItem("bid_lang") || "pt");
  const [modalOpen, setModalOpen] = useState(false);
  const t = translations[lang];

  useEffect(() => {
    localStorage.setItem("bid_lang", lang);
    document.documentElement.lang = lang === "fr" ? "fr" : lang === "en" ? "en" : "pt-BR";
  }, [lang]);

  const openConsult = () => setModalOpen(true);

  return (
    <div className="App" data-testid="bid-home">
      <Header lang={lang} setLang={setLang} t={t} onOpenConsult={openConsult} />
      <main>
        <Hero t={t} onOpenConsult={openConsult} />
        <About t={t} />
        <Services t={t} onOpenConsult={openConsult} />
        <Showcase t={t} />
        <ExtraServices t={t} />
        <Portfolio t={t} />
        <ImportExport t={t} onOpenConsult={openConsult} />
        <Commerce t={t} onOpenConsult={openConsult} />
        <ContactSection t={t} onOpenConsult={openConsult} />
      </main>
      <Footer t={t} />
      <FloatingWhatsApp t={t} lang={lang} />
      <ConsultationModal open={modalOpen} setOpen={setModalOpen} t={t} lang={lang} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
